import { colorCss } from "./colorCss";

/**
 * Canvas 2D drawing surface of the geometry layer, the fallback for
 * WebGL2 (plan §1): the same calls as webglSurface, and the renderers paint
 * their instances with the 2D context (instancedRenderer.init). Slower,
 * because every frame paints all visible geometry on the CPU, but the chart
 * looks the same.
 *
 * @param {HTMLCanvasElement} canvas - a canvas without a WebGL context
 * @param {Array<{ init: (context: CanvasRenderingContext2D) => void }>} renderers
 */
export const createCanvasSurface = (canvas, renderers) => {
  const context = canvas.getContext("2d", { alpha: false });
  let isClipped = false;

  renderers.forEach((renderer) => renderer.init(context));

  return {
    isReady: true,

    /** @param {{ init: (context: CanvasRenderingContext2D) => void }} renderer - added after the start */
    initRenderer: (renderer) => renderer.init(context),

    /** @param {number[]} background - RGBA in 0..1 */
    beginFrame: (background) => {
      if (isClipped) context.restore();

      isClipped = false;
      context.setTransform(1, 0, 0, 1, 0, 0);
      context.fillStyle = colorCss(background);
      context.fillRect(0, 0, canvas.width, canvas.height);
    },

    /** @param {number[]} color - RGBA in 0..1, fills the rectangle of clipTo */
    fillClip: (color) => {
      context.fillStyle = colorCss(color);
      context.fillRect(0, 0, canvas.width, canvas.height);
    },

    /** @param {{ x: number, y: number, width: number, height: number }} rect - device px from the top-left */
    clipTo: ({ x, y, width, height }) => {
      if (isClipped) context.restore();

      context.save();
      context.beginPath();
      context.rect(x, y, width, height);
      context.clip();
      isClipped = true;
    },

    destroy: () => {},
  };
};
